module.exports = __webpack_public_path__ + "static/img/DMC.3b102fc8.jpg";